<template>
  <div v-if="user.id" class="container" style="padding-bottom: 20vh; padding-top: 100px;">
    <app-profile-view :user="user" :city="user.city"></app-profile-view>
  </div>
</template>

<script>
  import axios from 'axios';

  import ProfileView from './ProfileView.vue'

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    components: {
      appProfileView: ProfileView,
    },
    data() {
      return {
        userID: null,
        user: {},
      }
    },
    created () {
      this.userID = this.$route.params.id
      this.getUser()

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
        this.timeToLoad = true
      },1000)
    },
    methods: {
      getUser() {
        // axios.get('/api/people?id='.concat(this.userID.toString()))
        axios.get('/api/publicemployers/?agency=4&id='.concat(this.userID.toString()))
          .then(res => {
            console.log(res.data)
            this.user = res.data[0]
          })
          .catch(error => console.log(error))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/employers/profile/PublicProfile.vue